import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { AsyncPipe } from '../../../../node_modules/@angular/common';

import { HttpErrorInterceptor } from 'src/app/modules/core/helpers/http-error.interceptor';
import { SharedModule } from 'src/app/modules/shared/shared.module';

import { CoreRoutingModule } from 'src/app/modules/core/core-routing.module';
import { LayoutComponent } from 'src/app/modules/core/layout/layout.component';
import { PageNotFoundComponent } from 'src/app/modules/core/page-not-found/page-not-found.component';

import { BackButtonDisableModule } from 'angular-disable-browser-back-button';

@NgModule({
  declarations: [
    LayoutComponent,
    PageNotFoundComponent
  ],
  imports: [
    CoreRoutingModule,
    CommonModule,
    SharedModule,
    BackButtonDisableModule.forRoot({
      preserveScrollPosition: true
    }),
  ],
  providers: [
    AsyncPipe,
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
  ],
  exports: [
    PageNotFoundComponent,
  ],
})
export class CoreModule {}
